export const riskTypeMap = {
	'1': 'General Risk',
	'2': 'Resident Clinical Risk',
	'3': 'Resident Non-Clinical Risk'
}

export const riskTypeOptions: { id: string, text: string }[] = Object.keys(riskTypeMap).map(riskTypeKey => ({ id: riskTypeKey, text: riskTypeMap[riskTypeKey] }));